import {MdNavigateNext} from 'react-icons/md'
import CarouselIcon from './icon'

export default function CarouselNextIcon() {
	return <CarouselIcon>
		<MdNavigateNext size="40px" />
	</CarouselIcon>
}